import React from 'react'
import styled from '@emotion/styled'
import {theme} from '../../../../theme'

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.primary};
  cursor: pointer;
  user-select: none;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    flex-shrink: 0;
  }
`

export function CheckboxField({field, value, onChange, disabled}) {
  return (
    <CheckboxLabel>
      <input
        type="checkbox"
        checked={value ?? false}
        disabled={disabled}
        onChange={e => onChange(field.key, e.target.checked)}
      />
      {field.label}
    </CheckboxLabel>
  )
}
